exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image__thumb[data-v-3015550e] {\n  max-width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: auto;\n  height: inherit;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n  transform: translate3d(-50%, -50%, 0);\n  pointer-events: none;\n}\n.image__thumb--placeholder[data-v-3015550e] {\n    width: 86.6%;\n    height: auto;\n}\n", ""]);

// exports
